module.exports = __webpack_public_path__ + "img/image_signing07@2x.512c20b4.png";